'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import handleIntent from '@/lib/react-native/services/react-native.intent.client'
import { INTENT_SAME_AS_WEB } from '@/lib/react-native/services/react-native.intent'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { useCallback } from 'react'
import { createShareURLIntent } from '../services/share.intents'

export type EmbedShareButtonProps = {
  /** The product name */
  title: string

  url: string
}
//FIXME: EmbedButton doesn't work on iOS with the current intent logic

export function EmbedShareButton({ title, url }: EmbedShareButtonProps) {
  const { t } = useTranslation(['EmbedShareButton'])

  return (
    <Button
      className="hidden embed:inline-flex"
      isRound
      variant="tertiary"
      size="sm"
      iconLeft={<Icon.Files />}
      onPress={useCallback(async () => {
        // Fallback to sending a share intent if the Web Share API is not supported (for Android)
        if (!navigator.share) {
          handleIntent(createShareURLIntent())
        } else {
          try {
            navigator.share({
              title,
              url, // We share the URL key as the path, the native app will be able to construct the full URL from it
            })
          } catch (error) {
            // The user may cancel the share action, we don't want to show an error in this case
            if (error instanceof Error && error.name === 'AbortError') {
              return
            }

            console.error('Error sharing', error)
          }
        }
      }, [title, url])}
      intent={INTENT_SAME_AS_WEB}
    >
      {t('EmbedShareButton:label')}
    </Button>
  )
}
